import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_professional_subscription_RowClass} from '../../../dbschema';

export class ProfessionalSubscriptionContainerModel extends BaseContainerModel {
  bl_aat_professional_subscription: bl_aat_professional_subscription_RowClass = new bl_aat_professional_subscription_RowClass();
}
